import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { selectDevice } from 'entities/device/lib';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { useSkeleton } from 'console/shared/features/skeleton/hook';
import { memo, useCallback } from 'react';
import { EventsBatches } from 'console/tabs/events/components/batches';
import { useCallbacks, useInView, usePartial } from 'shared/hooks/utils';
import { set_ui_settings } from 'console/redux/settings-actions';
import { pickDevice } from 'console/redux/main-actions';
import { leaveFromDashboard } from '../../actions';
export const DashboardDeviceEvents = memo(function DashboardDeviceEvents(props) {
    const [in_view, device_ref] = useInView();
    const Skeleton = useSkeleton(DefaultTabKey.eventsTab, in_view);
    return (_jsx(Box, { ref: device_ref, bgcolor: "background.paper", borderRadius: 4, children: _jsx(Skeleton, { children: _jsx(DeviceEvents, { ...props }) }) }));
});
const header_sx = {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
};
const DeviceEvents = memo(function DashboardDeviceEvents(props) {
    const { device_id } = props;
    const device = usePartialAppSelector(selectDevice, device_id);
    const setUISettings = useAction(set_ui_settings);
    const selectDefaultTabKey = useCallback(() => setUISettings({ selected_tab_key: DefaultTabKey.eventsTab }), []);
    const onDeviceClick = useCallbacks([
        useAction(usePartial(pickDevice, device_id)),
        useAction(leaveFromDashboard),
        selectDefaultTabKey,
    ]);
    return (_jsxs(Box, { display: "flex", height: "100%", flexDirection: "column", maxHeight: 500, children: [_jsx(Button, { onClick: onDeviceClick, fullWidth: true, color: "neutral_dark", sx: header_sx, children: _jsx(Typography, { width: "100%", p: 2, children: device?.name }) }), _jsx(EventsBatches, { active: true, device_id: device_id })] }));
});
